// modals

export const modalToDisplaySelector = (state) => state.modals.modalToDisplay;
